<template>
  <tr
    :class="{
      [depthSequence[depth % depthSequence.length].row]: true,
    }"
  >
    <td class="item-expansion" v-if="treeItem.item.metrics.children_count > 0">
      <div :style="{ 'padding-left': Math.min(depth, 12) * 12 + 'px' }">
        <v-btn
          v-if="!treeItem.expanded"
          icon="mdi-chevron-right"
          variant="plain"
          density="compact"
          @click="$emit('expand', treeItem)"
        ></v-btn>
        <v-btn
          v-else
          icon="mdi-chevron-down"
          variant="plain"
          density="compact"
          @click="$emit('collapse', treeItem)"
        ></v-btn>
      </div>
    </td>
    <td class="item-expansion" v-else></td>
    <td class="item-floc">{{ treeItem.item.functional_location }}</td>
    <td class="item-floc-desc">
      {{ treeItem.item.functional_location_description }}
    </td>
    <td class="item-is-asset">{{ treeItem.item.is_asset_text }}</td>
    <td class="item-asset-class">{{ treeItem.item.asset_class_name }}</td>
    <td class="item-actions">
      <v-btn
        icon="mdi-eye"
        variant="plain"
        density="compact"
        @click="$emit('view', treeItem)"
      ></v-btn>
    </td>
  </tr>
  <FunctionalLocationRow
    v-for="child in children"
    :key="child.item.id"
    :tree-item="child"
    :depth="depth + 1"
    @expand="$emit('expand', $event)"
    @collapse="$emit('collapse', $event)"
    @view="$emit('view', $event)"
  />
</template>

<script lang="ts" setup>
import { FunctionalLocation } from "@/classes";
import { TreeItem, depthSequence } from "./tree";
import { computed } from "vue";

const props = defineProps<{
  treeItem: TreeItem<FunctionalLocation>;
  depth: number;
}>();
defineEmits<{
  (e: "expand", treeItem: TreeItem<FunctionalLocation>): void;
  (e: "collapse", treeItem: TreeItem<FunctionalLocation>): void;
  (e: "view", treeItem: TreeItem<FunctionalLocation>): void;
}>();

const children = computed(() => {
  if (props.treeItem.expanded && Array.isArray(props.treeItem.children)) {
    return props.treeItem.children;
  } else {
    return [];
  }
});
</script>

<style lang="scss" scoped>
@use "./tree";
</style>
